<template>
  <div class="form-group has-feedback" :class="{'has-error': error}" style="margin-bottom: 0">
    <label :for=uniq class="control-label" :class="'col-sm-'+labelSize">{{label}}</label>

    <div :class="'col-sm-'+size">
      <input type=date class="form-control" :name=name :id=uniq :value=modelValue @change='$emit("update:modelValue", $event.target.value)' />
      <span class="help-block">{{error}}</span>
    </div>
    
    <slot></slot>
  </div>
</template>

<script>

import _ from "underscore"

export default {
  name: "Date",
  
  data()
  {
    return { 
       uniq: null,
    }
  },
  
  emits: [ 'update:modelValue' ],
  
  props: {
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    size: {
      type: Number,
      default: 6,
    },
    modelValue: {
       type: String,
    },
    labelSize: {
      type: Number,
      default: 3,
    },
    error: {
      type: String,
    }
  },
  
  mounted()
  {
    this.uniq = _.uniqueId("date")
  },
}
</script>
